import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Phone } from "lucide-react";
import { WhatsAppIcon } from "@/components/icons";
import { SITE, waLink } from "@/config/site";
import { track } from "@/lib/analytics";

export const WhatsAppFloat = () => {
  const [hidden, setHidden] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => setHidden(false), [pathname]);

  return (
    <>
      {/* Desktop floating WhatsApp */}
      <a
        href={waLink()}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-button"
        aria-label="Chat with NRI Property Services on WhatsApp"
        onClick={() => track("whatsapp_click", { location: "floating_button" })}
        className="group fixed bottom-6 right-6 z-[90] hidden items-center gap-3 rounded-full bg-[#1FA855] py-3 pl-4 pr-5 shadow-[0_18px_45px_-12px_rgba(31,168,85,0.65)] transition-[transform,box-shadow] duration-300 hover:-translate-y-1 sm:flex"
      >
        <span className="absolute inset-0 -z-10 animate-pulse-soft rounded-full bg-[#1FA855]/40" aria-hidden="true" />
        <WhatsAppIcon className="h-5 w-5 text-white" />
        <span className="font-display text-sm font-bold text-white">Chat on WhatsApp</span>
      </a>

      {/* Mobile sticky action bar */}
      {!hidden && (
        <div className="fixed inset-x-0 bottom-0 z-[90] border-t border-white/10 bg-navy-950/95 px-3 py-2.5 backdrop-blur-xl sm:hidden" data-testid="mobile-sticky-cta">
          <div className="grid grid-cols-[auto_1fr_1fr] items-center gap-2">
            <button
              onClick={() => setHidden(true)}
              aria-label="Hide quick actions"
              className="px-2 py-2 text-xs text-white/50"
              data-testid="mobile-sticky-hide"
            >
              ✕
            </button>
            <a
              href={SITE.phoneHref}
              onClick={() => track("phone_click", { location: "mobile_sticky" })}
              data-testid="mobile-sticky-call"
              className="flex items-center justify-center gap-2 rounded-full border border-white/20 py-3 font-display text-xs font-bold text-white"
            >
              <Phone className="h-3.5 w-3.5" /> Call
            </a>
            <a
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => track("whatsapp_click", { location: "mobile_sticky" })}
              data-testid="mobile-sticky-whatsapp"
              className="flex items-center justify-center gap-2 rounded-full bg-[#1FA855] py-3 font-display text-xs font-bold text-white"
            >
              <WhatsAppIcon className="h-3.5 w-3.5" /> WhatsApp
            </a>
          </div>
        </div>
      )}
    </>
  );
};
